var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, CustomElement, Prop, Watch, svg, unsafeHTML } from '@sick-davinci/ce-decorators';
import { style } from './Icon.style';
import { icons as actionIcons } from '@sick-davinci/material-icons/action';
import { icons as alertIcons } from '@sick-davinci/material-icons/alert';
import { icons as avIcons } from '@sick-davinci/material-icons/av';
import { icons as communicationIcons } from '@sick-davinci/material-icons/communication';
import { icons as contentIcons } from '@sick-davinci/material-icons/content';
import { icons as deviceIcons } from '@sick-davinci/material-icons/device';
import { icons as editorIcons } from '@sick-davinci/material-icons/editor';
import { icons as fileIcons } from '@sick-davinci/material-icons/file';
import { icons as hardwareIcons } from '@sick-davinci/material-icons/hardware';
import { icons as imageIcons } from '@sick-davinci/material-icons/image';
import { icons as mapsIcons } from '@sick-davinci/material-icons/maps';
import { icons as navigationIcons } from '@sick-davinci/material-icons/navigation';
import { icons as notificationIcons } from '@sick-davinci/material-icons/notification';
import { icons as placesIcons } from '@sick-davinci/material-icons/places';
import { icons as socialIcons } from '@sick-davinci/material-icons/social';
import { icons as toggleIcons } from '@sick-davinci/material-icons/toggle';
/**
 * Wrapper for material-icons so that they can be used in a DaVinCI application. 
 * There are three ways to integrate the icons, depending on your environment. 
 * See *Examples* below for details.
 * 
 * @example
 * There are three options to include icons in your application:
 * 
 * 1. Icon embedded in custom element as dependency (+++ generated size, because it's treeshackable, - compatibility (only for lit-elements)
 *     ```typescript
 *     ...
 *     import { icon_add_alert_lit } from '@sick-davinci/material-icons/alert/add_alert.icon.lit';
 *     ...
 *     render() {
 *         return html`<div>${icon_add_alert_lit}</div>`;
 *     }
 *     ...
 *     ```
 * 2. Icon with svg as src Name/attribute (+++ generated size, because it's treeshackable + compatibility (only strings)
 * 
 *     js:
 *     ```typescript    
 *     import { icon_add_alert } from '@sick-davinci/material-icons/alert/add_alert.icon';
 *     
 *     const element = document.createElement('davinci-icon-ref');
 *     element.src = icon_add_alert;
 *     ```
 *     in lit-html:
 *     ```typescript
 *     `<davinci-icon-ref .src="${icon_add_alert}"></davinci-icon-ref>'`
 *     ```
 *     template of angular:
 *     ```typescript
 *     <davinci-icon-ref [src]="icon_add_alert"></davinci-icon-ref>
 *     ```
 *     react:
 *     ```typescript
 *     return (<davinci-icon-ref src={icon_add_alert}></davinci-icon-ref>)
 *     ```
 *     plain html:
 *     ```html
 *     <davinci-icon-ref src="data:image/svg+xml,..."></davinci-icon-ref>
 *     <davinci-icon-ref src="data:image/svg+xml;base64,..."></davinci-icon-ref>
 *     ```
 * 3. Icon bundles with all available icons (--- generated size, +++ compatibility)
 * 
 *     js:
 *     ```typescript
 *     import { Icon } from '@sick-davinci/basic-elements';
 *     
 *     const element = document.createElement('davinci-icon');
 *     element.icon = "alert/add_alert";
 *     ```
 *     template of angular:
 *     ```typescript
 *     <davinci-icon icon="alert/add_alert"></davinci-icon>
 *     ```    
 *     react:
 *     ```typescript
 *     return (<davinci-icon icon="alert/add_alert"></davinci-icon>)
 *     ```    
 *     plain html:
 *     ```html
 *     <davinci-icon icon="alert/add_alert"></davinci-icon>
 *     ```
 * 
 */

export let Icon = (_dec = Component({
  tag: 'davinci-icon',
  style: [style]
}), _dec2 = Prop({
  reflectAsAttribute: false,
  type: String
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Watch('icon'), _dec5 = Reflect.metadata("design:paramtypes", [String, String]), _dec(_class = (_class2 = (_temp = class Icon extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "icon", _descriptor, this);

    this._iconCache = '<svg></svg>';
  }

  render() {
    return svg`${unsafeHTML(this._iconCache)}`;
  }

  iconChange(_, newValue) {
    if (typeof newValue === 'string') {
      const splittedIcon = newValue.split('/');
      let icon = '<svg></svg>';

      switch (splittedIcon[0]) {
        case 'action':
          icon = actionIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'alert':
          icon = alertIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'av':
          icon = avIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'communication':
          icon = communicationIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'content':
          icon = contentIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'device':
          icon = deviceIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'editor':
          icon = editorIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'hardware':
          icon = hardwareIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'file':
          icon = fileIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'image':
          icon = imageIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'maps':
          icon = mapsIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'navigation':
          icon = navigationIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'notification':
          icon = notificationIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'places':
          icon = placesIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'social':
          icon = socialIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        case 'toggle':
          icon = toggleIcons[splittedIcon[1]] || icon; // tslint:disable-line

          break;

        default:
          break;
      }

      this._iconCache = icon;
    }
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "iconChange", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "iconChange"), _class2.prototype)), _class2)) || _class);
//# sourceMappingURL=Icon.js.map